import React from "react";
import axios from "axios";
import APIURL from "../../Main/apiurl";

const create_salesman = async (salesman) => {
  try {
    let data = {
      name: salesman?.name,
      code: salesman?.code,
      email: salesman?.email,
      phone: salesman?.phone,
      tax: salesman?.tax,
      area: salesman?.area,
      city: salesman?.city,
      state: salesman?.state,
      country: salesman?.country,
      status: salesman?.status,
      contact_person_name: salesman?.contact_person_name,
      telephone: salesman?.telephone
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/create-salesman`,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const update_salesman = async (salesman) => {
  try {
    let data = {
      id: salesman?.id,
      name: salesman?.name,
      code: salesman?.code,
      email: salesman?.email,
      phone: salesman?.phone,
      tax: salesman?.tax,
      area: salesman?.area,
      city: salesman?.city,
      state: salesman?.state,
      country: salesman?.country,
      status: salesman?.status,
      contact_person_name: salesman?.contact_person_name,
      telephone: salesman?.telephone
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/update-salesman`,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const delete_salesman = async (salesman) => {
  try {
    let data = {
      id: salesman?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/delete-salesman`,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const get_salesman = async (salesman) => {
  try {
    let data = {
      id: salesman?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-salesman`, data, config);

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const get_all_salesman = async (salesman) => {
  try {
    const data = {
      search: salesman?.search,
      sort: salesman?.sort,
      status: salesman?.status,
      page: salesman?.page,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-salesman`,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

export {
  create_salesman,
  update_salesman,
  delete_salesman,
  get_salesman,
  get_all_salesman,
};
